import {
  Dialog, DialogContent, DialogActions, Select, MenuItem, Divider, FormControl, InputLabel,
} from '@mui/material';
import { UserSearch } from 'components/UserSearch';
import { User } from 'lib/types/users';
import { List } from 'lib/types/index';
import { useState, useEffect } from 'react';
import { useRouter } from 'next/router';
import { toNumber } from 'lodash';
import { useSelectedUser } from 'components/UserSearch/useSelectedUser';
import { useCurrentUser } from 'lib/contexts/ApplicationState';

interface Props {
  onClose: () => void;
  onSave: (users: User[], listId: number) => void;
  lists: List[];
  publicId?: string;
}
export const ListUserSearchModal = ({
  onClose, onSave, lists, publicId,
}: Props) => {
  const [users, setUsers] = useState<User[]>([]);
  const router = useRouter();
  const [listId, setListId] = useState<number>();
  const [loading, setLoading] = useState(true);
  const currentUser = useCurrentUser();

  const { onHandleSelectUser, selectedUser } = useSelectedUser(null);

  const onSelectAccount = (value: User[]) => {
    setUsers(value.filter((u) => !!u.id));
    const toAdd = value.filter((u) => !u.id);
    toAdd.map(async (u) => onHandleSelectUser(u, currentUser?.hasPaidTeam));
  };

  useEffect(() => {
    if (publicId) {
      const l = lists.filter((ls) => ls.publicId === publicId);
      setListId(l[0]?.id);
      setLoading(false);
    }
  }, [publicId]);

  useEffect(() => {
    if (selectedUser) {
      setUsers([...users, selectedUser]);
    }
  }, [selectedUser]);

  return (
    <Dialog open maxWidth="sm" fullWidth>
      <div className="p-5">
        <h1 className="font-bold text-xl text-orange">
          Add creators to list
        </h1>
        <DialogContent>
          <FormControl className="w-full relative" size="small">
            <InputLabel id="list-label">List</InputLabel>
            {loading ? <p>Loading...</p> : (
              <Select
                labelId="list-label"
                id="list-select"
                name="list-select"
                value={listId}
                label="List"
                onChange={(e) => setListId(toNumber(e.target.value))}
              >
                {lists?.map((l) => (
                  <MenuItem key={l.id} value={l.id}>
                    {l.name}
                  </MenuItem>
                ))}
                <Divider />
                <MenuItem value="manage" onClick={() => router.push('/lists')}>Manage Lists</MenuItem>
              </Select>
            )}
            <div className="pt-5">
              <UserSearch
                label="Name or username"
                onChange={(_, value) => onSelectAccount(value)}
                isCreatableSearch
                multiple
                value={users}
              />
            </div>
          </FormControl>
        </DialogContent>
        <DialogActions>
          <button
            onClick={() => {
              setUsers([]);
              onClose();
            }}
            color="inherit"
            type="button"
            className="btn-primary-outlined mr-2"
          >
            Cancel
          </button>
          <button
            onClick={() => {
              if (listId) {
                onSave(users, listId);
                onClose();
              }
            }}
            color="inherit"
            type="button"
            className="btn-primary mr-2"
            disabled={!listId || users.length === 0}
          >
            Save
          </button>
        </DialogActions>
      </div>
    </Dialog>
  );
};
